export default "__VITE_ASSET__CwHNL1_Y__"